// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberSearchResponseModel {
    static getAttributeTypeMap() {
        return PrescriberSearchResponseModel.attributeTypeMap;
    }
}
PrescriberSearchResponseModel.discriminator = undefined;
PrescriberSearchResponseModel.additionalProperties = false;
PrescriberSearchResponseModel.attributeTypeMap = [
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": "Array<PrescriberModel>"
    },
    {
        "name": "hasAdditionalMatches",
        "baseName": "hasAdditionalMatches",
        "type": "boolean"
    },
];
//# sourceMappingURL=prescriberSearchResponseModel.js.map